import { render, staticRenderFns } from "./ExpedienteCaratula.vue?vue&type=template&id=31a8062e&"
import script from "./ExpedienteCaratula.vue?vue&type=script&lang=js&"
export * from "./ExpedienteCaratula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports